interface Config {
  apiUrl: string;
  environment: string;
  features: {
    enableSubscription: boolean;
    disableAuth: boolean;
    disableSubscription: boolean;
  };
}

const config: Config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  environment: process.env.REACT_APP_ENV || 'development',
  features: {
    enableSubscription: process.env.REACT_APP_ENABLE_SUBSCRIPTION === 'true',
    disableAuth: process.env.REACT_APP_DISABLE_AUTH === 'true',
    disableSubscription: process.env.REACT_APP_DISABLE_SUBSCRIPTION === 'true',
  },
};

export const isProduction = config.environment === 'production';
export const isDevelopment = config.environment === 'development';

export default config; 